const ethChainId = process.env.NEXT_PUBLIC_DEPOSIT_ETH_CHAIN_ID as string;
const bscChainId = process.env.NEXT_PUBLIC_DEPOSIT_BSC_CHAIN_ID as string;

export { bscChainId, ethChainId };
